import { render, staticRenderFns } from "./RecycleConfirm.vue?vue&type=template&id=b8a5c00e&scoped=true"
import script from "./RecycleConfirm.vue?vue&type=script&lang=ts"
export * from "./RecycleConfirm.vue?vue&type=script&lang=ts"
import style0 from "./RecycleConfirm.vue?vue&type=style&index=0&id=b8a5c00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5c00e",
  null
  
)

export default component.exports